import React, { useState, Fragment } from 'react';

import './styles.css';

import { Modal } from './../Modal/Modal';
import { Gallery } from './../Gallery/Gallery';

export const Product = ({ product }) => {
    const { image, gallery } = product;
	const [showModal, setModal] = useState(false);

    return (
    	<Fragment>
    		{
	   			showModal && 
	   			<Modal onClose={() => setModal(false)}>
	   				<Gallery gallery={gallery} />
	   			</Modal> 
	   		}
	        <div className="product" onClick={() => setModal(true)}>
	            <img alt="Producto A lo Venezolano" src={image}/>
	        </div>
        </Fragment>
    )
};